

























































































import PalletPatternList from '@/components/PalletPatternList'
import NavButton from '@/components/shared/NavButton'
import ConfirmDialog from '@/components/shared/ConfirmDialog'
import SendToRobotDialog from '@/components/SendToRobotDialog'
import {
  ISnackbar,
  IDialog,
  PalletPattern,
  SendToRobotParameters,
  Settings,
  LayerPattern,
  Pallet, GripperSettings, MachineSettings
} from '@/model'
import { mapGetters } from 'vuex'
import { Pages, getPathPrefix } from '@/pages'
import { Component, Vue} from 'vue-property-decorator'
import { get, post } from '@/api/utils/http-utils.js'
import axios, { AxiosError, AxiosResponse } from 'axios'
import { errorHandler, getUrl } from '@/api/utils/http-helpers'
import { reorderAll } from '@/libs/pattern/check'
import {
  isRI20,
  hasRotationLimitations,
  getGripperTypeDescription,
} from '@/libs/pattern/gripperUtils'
import {
  layerPatternContainsRotationIssues,
  layerPatternContainsCollisions,
  layerPatternContainsGripperIssues,
  hasDoublePlaceOptionIssue,
  hasDifferentSections
} from '@/libs/pattern/layerPatternUtils'
import { RobotTypeEnum } from '@/generated/model/robotTypeEnum'
import CopyPatternDialog from '@/components/CopyPatternDialog.vue'
import { copyPatternObject } from '@/libs/palletPattern'
import { permissions } from '@/userUtils'
import CancelValidationDialog from '@/components/CancelValidationDialog.vue'

@Component({
  components: {
    CancelValidationDialog,
    CopyPatternDialog,
    PalletPatternList: PalletPatternList,
    NavButton: NavButton,
    ConfirmDialog: ConfirmDialog,
    SendToRobotDialog: SendToRobotDialog
  },
  computed: {
    ...mapGetters ('palletpatterns', [
      'palletPatterns',
      'palletPatternsCount',
      'isLoading',
      'isLoaded',
      'selectedEntity'
    ]),
    ...mapGetters ('user', ['userPermissions']),
    ...mapGetters ('environment', ['isLicenseValid']),
    ...mapGetters('machinesettings', [ 'machinesettings' ]),
    pathPrefix: getPathPrefix,
    ...mapGetters ('settings', ['settings']),
    ...mapGetters ('palletpatterns', ['selectedEntity'])
  },
  created () {
    this.$store.dispatch('palletpatterns/loadPalletPatterns')
  }
})
export default class ViewPalletPatterns extends Vue {
  private homeRouteLink: any = Pages.HOME.routeLink
  private createRouteLink: any = Pages.CREATEPALLETPATTERN.routeLink
  private machinesettings!: MachineSettings
  private userPermissions!: string[]
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }
  private confirmRemoveDialogProps: IDialog = {
    title: this.localText('patternList.titleDel'),
    text: this.localText('patternList.messageDelete'),
    cancelBtn: this.localText('general.cancel'),
    acceptBtn: this.localText('general.delete'),
    acceptColor: 'error'
  }
  private sendToRobotDialogProps: IDialog = {
    title: this.localText('patternList.titleSend'),
    text: '',
    cancelBtn: this.localText('general.cancel'),
    acceptBtn: this.localText('patternList.acceptSend')
  }
  private confirmForcedSendDialogProps: IDialog = {
    title: this.localText('patternList.titleNotProcessed'),
    text: this.localText('patternList.messageNotProcessed1') + '<br/>' + this.localText('patternList.messageNotProcessed2'),
    cancelBtn: this.localText('general.cancel'),
    acceptBtn: this.localText('patternList.acceptNotProcessed'),
  }
  private showConfirmRemoveDialog: boolean = false
  private showSendToRobotDialog: boolean = false
  private showConfirmForcedSendDialog: boolean = false
  private showCopyPatternDialog: boolean = false
  private forcedSendParameters: SendToRobotParameters | undefined
  private focusedPalletPattern!: PalletPattern
  private isLicenseValid!: boolean
  private settings!: Settings
  private selectedEntity!: PalletPattern
  private selectedFile: any
  private selectedPatternName: string = (this.selectedEntity) ? this.selectedEntity.name : ''
  private verifyInProgress: boolean = false

  private showConfirmSendDialog: boolean = false
  private confirmSendDialogProps: IDialog = {
    title: '',
    text: '',
    cancelBtn: this.localText('general.cancel'),
    acceptBtn: this.localText('general.confirm')
  }

  private localText (arg: string, values?: string[]): string {
    return String(this.$t(arg, values))
  }

  private createPattern () {
    if (this.isCreatePatternDisabled()) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    this.$store.dispatch('palletpatterns/setStep', 1)
    this.$router.push({ path: 'create-pallet-pattern' })
  }

  private async routeToEdit (palletPattern: PalletPattern) {
    if (!this.userPermissions.includes(permissions.MODIFYPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    if (!this.isLicenseValid) {
      this.$router.push({
        name: Pages.LICENSE.routeName,
        params: { userActionThatRequiresLicense: this.localText('patternList.editPattern') }
      })
      return
    }
    await this.$store.dispatch('palletpatterns/getSelectedEntity', palletPattern.guid)
    await this.$store.dispatch('palletpatterns/setStep', 1)
    this.$router.push({ path: `edit-pallet-pattern/${palletPattern.guid}` })
  }

  private async routeToDetails (palletPattern: PalletPattern) {
    await this.$store.dispatch('palletpatterns/getSelectedEntity', palletPattern.guid)
    this.$router.push({ path: `view-details/${palletPattern.guid}` })
  }

  private openRemoveDialog (palletPattern: PalletPattern) {
    if (!this.userPermissions.includes(permissions.DELETEPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    if (!this.isLicenseValid) {
      this.$router.push({
        name: Pages.LICENSE.routeName,
        params: { userActionThatRequiresLicense: this.localText('patternList.removePattern') }
      })
      return
    }
    this.focusedPalletPattern = palletPattern
    this.showConfirmRemoveDialog = true
  }

  private async removePalletPattern () {
    await this.$store.dispatch('palletpatterns/removePalletPattern', this.focusedPalletPattern)
    this.showConfirmRemoveDialog = false
    this.snackbar.show = true
    this.snackbar.color = 'success'
    this.snackbar.text = this.localText('patternList.patternDeleted') + ` '${this.focusedPalletPattern.name}'`
  }

  private async recalculatePattern (guid: string) {
    // load
    await this.$store.dispatch('palletpatterns/getSelectedEntity', guid)
    const source = this.selectedEntity

    // reorder
    const updated = reorderAll(source)

    // save
    await this.$store.dispatch('palletpatterns/updatePalletPattern', { guid: source.guid, palletPattern: updated })
  }

  private async downloadScript (palletPattern: PalletPattern, robot: string) {
    if (!this.userPermissions.includes(permissions.PORTPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    await this.recalculatePattern(palletPattern.guid!)

    const url = '/pallet-patterns/' + palletPattern.guid + '/program/' + robot
    get(url)
      .then((resp: AxiosResponse) => {
        if (resp) {
          window.location.href = getUrl(url)
        }
      })
      .catch((e: AxiosError) => {
        errorHandler(e.toString())
        let errorMessage = this.localText('patternList.scriptNotFound')
        if (e.response!.status === 500 && e.response!.data.message.startsWith('Failed to create program')) {
          errorMessage = this.localText('patternList.scriptGenerationFailed')
        }
        this.snackBarHandler(true, 'error', errorMessage)
        // console.log('[ERROR] script file not found,', e.toString())
      })
  }

  private isAnyEmptyPallet (pallet: Pallet | undefined) {
    const layers = pallet && pallet.layers ? pallet.layers.map(p => p.layerPattern) : []
    const patterns = pallet && pallet.layerPatterns ? pallet.layerPatterns.filter(p => layers.includes(p.name)) : []

    const hasEmptyPallet = (pattern: LayerPattern) => {
      return !(pattern && pattern.boxPositions && pattern.boxPositions.length > 0
        && pattern.boxPositionsAlt && pattern.boxPositionsAlt.length > 0)
    }
    return patterns.some(p => hasEmptyPallet(p))
  }

  private hasCollisions(pattern: PalletPattern | undefined) {
    if (!isRI20(this.selectedEntity.programSettings!.robotType!) || !pattern || !pattern.pallet || !pattern.pallet.layerPatterns) {
      return false
    }
    return pattern.pallet.layerPatterns.some(lp => layerPatternContainsCollisions(lp, pattern, this.machinesettings, 'L') ||
        layerPatternContainsCollisions(lp, pattern, this.machinesettings, 'R'))
  }

  private hasGripperIssues(pattern: PalletPattern | undefined) {
    if (!isRI20(this.selectedEntity.programSettings!.robotType!) || !pattern || !pattern.pallet || !pattern.pallet.layerPatterns) {
      return false
    }
    if (this.hasDifferentGripperType(this.selectedEntity, pattern.machineSettings, this.machinesettings, this.machinesettings.gripperSettings!)) {
      return false // trigger confirmation dialog for different grippers instead
    }
    return pattern.pallet.layerPatterns.some(p => layerPatternContainsGripperIssues(p, pattern, this.machinesettings, 'L')
        || layerPatternContainsGripperIssues(p, pattern, this.machinesettings, 'R'))
  }

  private hasRotationIssues(pattern: PalletPattern | undefined) {
    if (!this.selectedEntity.machineSettings
        || !hasRotationLimitations (this.selectedEntity.programSettings!.robotType!, this.selectedEntity.machineSettings.gripperSettings!.gripperType!)
        || !pattern || !pattern.pallet || !pattern.pallet.layerPatterns) {
      return false
    }
    return pattern.pallet.layerPatterns.some(p => layerPatternContainsRotationIssues(p, pattern, this.machinesettings, 'L') ||
        layerPatternContainsRotationIssues(p, pattern, this.machinesettings, 'R'))
  }

  private hasIgnoredIssues(pallet: Pallet | undefined) {
    const layers = pallet && pallet.layers ? pallet.layers.map(p => p.layerPattern) : []
    const patterns = pallet && pallet.layerPatterns ? pallet.layerPatterns.filter(p => layers.includes(p.name)) : []

    const ignoredRotation = this.selectedEntity.machineSettings
        && hasRotationLimitations(this.selectedEntity.programSettings!.robotType!, this.selectedEntity.machineSettings!.gripperSettings!.gripperType!)
        && patterns.some(p => {
      return (p && p.ignoreRotation && p.ignoreRotation.length > 0
          || p.ignoreRotationAlt && p.ignoreRotationAlt.length > 0)
    })
    const ignoredGripperOutside = patterns.some(p => {
      return (p && p.ignoreGripper && p.ignoreGripper.length > 0
          || p.ignoreGripperAlt && p.ignoreGripperAlt.length > 0)
    })
    // console.log('hasIgnoredIssues: ', ignoredRotation, ignoredGripperOutside)
    if (ignoredGripperOutside && ignoredRotation) {
      return `${ this.localText ('patternList.gripperIssuesInPattern') }<br>
        ${ this.localText ('patternList.rotationIssuesInPattern') } ${ this.localText ('patternList.ignoredRotationExtraInfo') }`
    } else if (ignoredRotation) {
      return `${ this.localText('patternList.rotationIssuesInPattern') } ${ this.localText ('patternList.ignoredRotationExtraInfo') }`
    } else if (ignoredGripperOutside) {
      return this.localText('patternList.gripperIssuesInPattern')
    }
    return ''
  }

  private isGripperTypeDifferent(palletMachineSettings: MachineSettings | undefined, gripperSettings: GripperSettings) {
    return palletMachineSettings === undefined
        || palletMachineSettings.gripperSettings !== undefined
        && (palletMachineSettings.gripperSettings.gripperType !== gripperSettings.gripperType
            || palletMachineSettings.gripperSettings.gripperSections !== gripperSettings.gripperSections) // in case of custom gripper
  }

  private hasDifferentGripperType(selectedPattern: PalletPattern, patternMachineSettings: MachineSettings | undefined, machineSettings: MachineSettings, gripperSettings: GripperSettings) {
    if (isRI20(machineSettings.robotType!) && this.isGripperTypeDifferent(patternMachineSettings, gripperSettings)) {
      return true
    }
    return hasDifferentSections(selectedPattern.pallet!.layerPatterns!, machineSettings, selectedPattern.programSettings!.robotType!)
  }

  private hasDifferentRobotType(selectedPattern: PalletPattern | undefined) {
    let errorMessage: string = ''
    const patternRobotType = selectedPattern!.programSettings!.robotType!
    const targetRobotType = this.machinesettings.robotType!
    if (patternRobotType !== targetRobotType) {
      errorMessage = this.localText('patternList.wrongRobotType', [patternRobotType, targetRobotType])
    }
    return errorMessage
  }

  private async showSendConfirmation (palletPattern: PalletPattern) {
    if (!this.userPermissions.includes(permissions.TRANSFERPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    await this.recalculatePattern(palletPattern.guid!)
    const pl = this.$refs.patternList as any

    await this.$store.dispatch('palletpatterns/getSelectedEntity', palletPattern.guid)
    this.focusedPalletPattern = palletPattern
    if (this.isAnyEmptyPallet(this.selectedEntity.pallet)) {
      this.snackBarHandler(true, 'warning', this.localText('patternList.emptyPalletPattern'))
      pl.setSending(false, '')
      return
    }
    if (this.hasCollisions(this.selectedEntity)) {
      this.snackBarHandler(true, 'warning', this.localText('patternList.collisionsInPattern'))
      pl.setSending(false, '')
      return
    }
    if (this.hasGripperIssues(this.selectedEntity)) {
      this.snackBarHandler(true, 'warning', this.localText('patternList.gripperIssuesInPattern'))
      pl.setSending(false, '')
      return
    }
    if (this.hasRotationIssues(this.selectedEntity)) {
      this.snackBarHandler(true, 'warning', this.localText('patternList.rotationIssuesInPattern'))
      pl.setSending(false, '')
      return
    }
    const robotTypeMessage = this.hasDifferentRobotType(this.selectedEntity)
    if (robotTypeMessage) {
      this.snackBarHandler(true, 'warning', robotTypeMessage)
      pl.setSending(false, '')
      return
    }

    const palletMachineSettings = (this.selectedEntity.machineSettings !== undefined) ? JSON.parse(JSON.stringify(this.selectedEntity.machineSettings)) : undefined
    let gripperSettings: GripperSettings = {}
    if (this.machinesettings.gripperSettings !== undefined) {
      gripperSettings = {...this.machinesettings.gripperSettings}
    }
    const patternHasDifferentGripperType = this.hasDifferentGripperType(this.selectedEntity, palletMachineSettings, this.machinesettings, gripperSettings)
    const ignoredIssues = this.hasIgnoredIssues(this.selectedEntity.pallet)
    const mismatchDoublePlaceOption = hasDoublePlaceOptionIssue(this.selectedEntity!.pallet!.layerPatterns!, this.machinesettings!)

    this.showConfirmSendDialog = patternHasDifferentGripperType || ignoredIssues !== '' || mismatchDoublePlaceOption
    if (this.showConfirmSendDialog) {
      let dialogText = ''
      if (mismatchDoublePlaceOption) {
        dialogText = `${this.localText('patternList.doublePlaceIssue')} ${this.localText('machineSettings.disableDoublePlaceInfo')}`
      }
      if (ignoredIssues.length > 0) {
        if (dialogText.length > 0) {
          dialogText += '<br>'
        }
        dialogText += `${ ignoredIssues }`
      }
      if (patternHasDifferentGripperType) {
        if (palletMachineSettings !== undefined) {
          const gripperTypePattern = this.isGripperTypeDifferent (palletMachineSettings, gripperSettings) ? getGripperTypeDescription(palletMachineSettings.gripperSettings) : ''
          const gripperType = getGripperTypeDescription(gripperSettings)
          if (dialogText.length > 0) {
            dialogText += '<br>'
          }
          dialogText += `${ this.localText ('patternList.gripperTypeChangedPart1') } ${ gripperTypePattern }
          ${ this.localText ('patternList.gripperTypeChangedPart2') } ${ gripperType }.`
        } else {
          if (dialogText.length > 0) {
            dialogText += '<br>'
          }
          dialogText += `${ this.localText ('patternList.noSavedGripperType') }`
        }
      }

      if (dialogText.length > 0) {
        dialogText += `<br><br>${ this.localText ('patternList.wantToProceed') }`
      }
      this.confirmSendDialogProps.title = 'Ignore issues?'
      this.confirmSendDialogProps.text = dialogText
    }

    if (!this.showConfirmSendDialog) {
      await this.sendToRobot()
    }
  }

  private cancelConfirmSend() {
    (this.$refs.patternList as any).setSending(false, '')
    this.showConfirmSendDialog = false
  }

  private async sendToRobot () {
    this.showConfirmSendDialog = false
    let ss = this.settings.sendToRobotParams!

    // set empty settings if robot is RC10_UR or RC12
    const skipSettings = this.selectedEntity.programSettings!.robotType === RobotTypeEnum.RC10_UR
        || this.selectedEntity.programSettings!.robotType === RobotTypeEnum.RC12
        || this.selectedEntity.programSettings!.robotType === RobotTypeEnum.RC20
    if (skipSettings) {
      ss = {}
    }
    // check if robot is FANUC, KUKA etc. and settings are not defined
    if (!skipSettings && (ss == null || ss.server == null)) {
      this.snackBarHandler(true, 'warning', this.localText('patternList.checkConnect'))
      setTimeout(() => {
        this.$router.push({ path: `/settings` })
      }, 2000)
      return
    }
    // try to 'send' to robot if settings are ok (empty settings for UR, Generic)
    this.sendToRobotHandler(ss)
  }

  private sendToRobotHandler (params: SendToRobotParameters) {
    this.showSendToRobotDialog = false
    const pl = this.$refs.patternList as any
    pl.setSending(true, this.focusedPalletPattern.name)

    // fix
    if (params != null && typeof params.port === 'string') {
      params.port = parseInt(params.port, 10)
    }

    const url = '/pallet-patterns/' + this.focusedPalletPattern.guid + '/send-to-robot'
    const currentGUID = this.focusedPalletPattern.guid
    this.$store.dispatch ('palletpatterns/setSending', currentGUID)
    post(url, JSON.stringify(params))
        .then((resp: AxiosResponse) => {
          if (resp) {
            this.snackBarHandler(true, 'success', this.localText('patternList.sendOk'))
            this.$store.dispatch ('palletpatterns/removeSending', currentGUID)
          }
        })
        .catch((e: AxiosError) => {
          if (e.response!.status === 409) {
            this.$store.dispatch ('palletpatterns/removeSending', currentGUID)
            this.openForcedSendDialog(params)
          } else {
            this.snackBarHandler(true, 'error', this.localText('patternList.sendNOk'))
            errorHandler(e.toString())
            this.$store.dispatch ('palletpatterns/removeSending', currentGUID)
          }
        }).finally (() => pl.setSending (false, ''))
  }

  private openForcedSendDialog (params: SendToRobotParameters) {
    this.forcedSendParameters = Object.assign({}, params)
    this.forcedSendParameters.force = true
    this.showConfirmForcedSendDialog = true
  }

  private performForcedSend () {
    this.showConfirmForcedSendDialog = false
    this.sendToRobotHandler(this.forcedSendParameters!)
    this.forcedSendParameters = undefined
  }

  private snackBarHandler (state: boolean, color: string, text: string) {
    this.snackbar.show = state
    this.snackbar.color = color
    if (text && text !== '') {
      this.snackbar.text = text
    }
  }

  private closeSnackbar () {
    this.snackbar.show = false
  }

  private showImportDialog() {
    if (!this.userPermissions.includes(permissions.PORTPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    const fileInput = this.$refs.fileInput as HTMLInputElement | undefined
    fileInput!.click()
  }

  private importFileChange (e: any) {
    try {
      if (e.target.files[0] != null) {
        this.selectedFile = e.target.files[0]
        e.target.value = ''
        this.importPatterns()
      }
    } catch (e) {
      console.log('[ERROR] ', e)
    }
  }

  private async importPatterns () {
    console.log('Uploading to ' + getUrl('') + ' ' + this.selectedFile.name)

    const url = '/pallet-patterns/import'
    const opt = { headers: { 'Content-Type': 'application/json' } }

    post(url, this.selectedFile, opt)
      .then((response: AxiosResponse) => {
        console.log('File uploaded:' + response.status + ',' + response.statusText)
        this.snackBarHandler(true, 'success', this.localText('patternList.importPatternSuccess'))

        // refresh list
        this.$store.dispatch('palletpatterns/loadPalletPatterns')
      })
      .catch((error: AxiosError) => {
        console.log(JSON.stringify(error))
        this.snackBarHandler(true, 'error', this.localText('patternList.importPatternFail'))
      })
  }

  private async exportPatterns () {
    if (!this.userPermissions.includes(permissions.PORTPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    console.log('export')
    const url = '/pallet-patterns/export'
    get(url)
      .then((res: AxiosResponse) => {
        if (res.data) {
          const a = document.createElement('a')
          a.setAttribute('href', getUrl(url))
          // @ts-ignore
          // noinspection JSConstantReassignment
          a.style = 'display: none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      })
      .catch((e: AxiosError) => {
        console.log('error', e.toString())
        errorHandler(e.toString())
        this.snackBarHandler(true, 'error', this.localText('patternList.scriptNotFound'))
      })
  }

  private isCreatePatternDisabled() {
    return !this.userPermissions.includes(permissions.CREATEPALLETPATTERN)
  }

  private async openCopyPatternDialog(palletPattern: PalletPattern) {
    if (this.isCreatePatternDisabled()) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    await this.$store.dispatch('palletpatterns/getSelectedEntity', palletPattern.guid)
    this.selectedPatternName = this.selectedEntity.name
    this.showCopyPatternDialog = true
  }

  private async copyPattern(newName: string) {
    this.showCopyPatternDialog = false
    const patternCopy = copyPatternObject(this.selectedEntity)
    patternCopy.name = newName
    await this.$store.dispatch('palletpatterns/addPalletPattern', patternCopy)

    if (this.$store.state.palletpatterns.error) {
      this.snackBarHandler(true, 'error', this.localText('patternList.copyPatternFail'))
    } else {
      this.snackBarHandler(true, 'success', this.localText('patternList.copyPatternSuccess'))
      await this.$store.dispatch('palletpatterns/loadPalletPatterns')
    }
  }

  private async validatePattern(pattern: PalletPattern) {
    if (!this.userPermissions.includes(permissions.MODIFYPALLETPATTERN)) {
      this.snackBarHandler(true, 'warning', this.localText('settings.permissionDenied'))
      return
    }
    await this.$store.dispatch('palletpatterns/getSelectedEntity', pattern.guid)
    const url = getUrl('/pallet-patterns/' + pattern.guid + '/validate-pattern')
    this.verifyInProgress = true
    await axios
        .post(url)
        .then( resp => {
          if (resp && this.verifyInProgress) {
            this.snackBarHandler(true, 'success', this.localText('patternList.validationOK'))
            this.$store.dispatch ('settings/setStatusSocketServer', 'available')
          }
        })
        .catch((e: AxiosError) => {
          if (e.response!.status === 502) {
            this.snackBarHandler(true, 'error', this.localText('patternList.badGateway'))
            this.$store.dispatch ('settings/setStatusSocketServer', 'unavailable')
          } else if (e.response!.status === 504) {
            const msg = e.response!.data!.message!.toString()
            const timeout = msg.substring(msg.indexOf('(') + 1, msg.indexOf(')'))
            this.snackBarHandler(true, 'error', this.localText('patternList.gatewayTimeout', [timeout]))
            this.$store.dispatch ('settings/setStatusSocketServer', 'unknown')
          } else {
            this.snackBarHandler(true, 'error', this.localText('patternList.validationNOK'))
            errorHandler(e.toString())
            this.$store.dispatch ('settings/setStatusSocketServer', 'available')
          }
        })
        .finally(() => {
          this.$store.dispatch('palletpatterns/loadPalletPatterns')
          this.verifyInProgress = false
        })
  }

  private async cancelValidation() {
    const url = getUrl('/pallet-patterns/' + this.selectedEntity.guid + '/cancel')
    await axios
        .post(url, null, { params: {action: 'validate'} })
        .then(() => {
          this.snackBarHandler(true, 'info', this.localText('patternList.validationCanceled'))
        })
        .finally(() => {
          this.$store.dispatch('palletpatterns/loadPalletPatterns')
          this.verifyInProgress = false
        })
  }
}
